import { NavItem } from '../useGetNavigationData';

export const DropdownMenu = ({
  isOpen,
  navItems,
}: {
  isOpen: boolean;
  navItems: NavItem[];
}) => {
  return (
    <>
      <div
        className={`pointer-events-none fixed left-0 top-[73px] z-[-1] hidden h-[calc(100vh-73px)] w-full bg-black transition-opacity duration-500 m:block ${
          isOpen ? 'opacity-20' : 'invisible opacity-0'
        }`}
      />
      <div
        className={`fixed right-s top-[85px] w-[280px] border-[1px] border-structure-80 shadow-black-m transition-all duration-[250ms] ease-in-out m:right-0 m:top-[70px] m:w-full m:border-0 m:shadow-transparent ${
          isOpen ? 'opacity-100' : 'invisible -translate-y-[10px] opacity-0'
        }`}
      >
        <div className="grid grid-cols-1 gap-xl bg-white p-xl">
          {/* Loan dashboard section (mobile only) */}
          {navItems.length > 0 && (
            <div className="hidden flex-col items-start justify-start m:flex">
              <span className="w-full border-b border-[#f2f2f2] pb-l text-xs uppercase text-[#999]">
                Loan Dashboard
              </span>
              {navItems.map(({ label, href }) => (
                <a
                  key={href}
                  href={href}
                  className="w-full border-b border-[#f2f2f2] py-[8px] text-[16px] leading-[18px] text-[var(--primary)] no-underline hover:underline"
                >
                  {label}
                </a>
              ))}
            </div>
          )}

          {/* Account section */}
          <div className="flex flex-col items-start justify-start">
            <span className="w-full border-b border-[#f2f2f2] pb-l text-xs uppercase text-[#999]">
              Account
            </span>

            <a
              href="/account/company/"
              data-testid="company-link"
              className="w-full border-b border-[#f2f2f2] py-[8px] text-[16px] leading-[18px] text-[var(--primary)] no-underline hover:underline"
            >
              Profile
            </a>

            <a
              href="/account/history/"
              data-testid="history-link"
              className="w-full border-b border-[#f2f2f2] py-[8px] text-[16px] leading-[18px] text-[var(--primary)] no-underline hover:underline"
            >
              Transactions
            </a>

            <a
              href="/account/trading/"
              data-testid="trading-data-link"
              className="w-full border-b border-[#f2f2f2] py-[8px] text-[16px] leading-[18px] text-[var(--primary)] no-underline hover:underline"
            >
              Upload Documents
            </a>

            <a
              href="/account/contracts/"
              data-testid="contracts-data-link"
              className="w-full border-b border-[#f2f2f2] py-[8px] text-[16px] leading-[18px] text-[var(--primary)] no-underline hover:underline"
            >
              Contracts
            </a>

            <a
              href="https://www.iwoca.co.uk/compliance/terms-of-use#1-general"
              target="_blank"
              rel="noreferrer"
              className="w-full border-b border-[#f2f2f2] py-[8px] text-[16px] leading-[18px] text-[var(--primary)] no-underline hover:underline"
            >
              Terms of use
            </a>

            <a
              href="/my_account/logout/"
              data-testid="logout-link"
              className="w-full border-b border-[#f2f2f2] py-[8px] text-[16px] leading-[18px] text-[#960b03] no-underline hover:underline"
            >
              Logout
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
